import React from "react"
import { AppFunctionComponent } from "../../../types"

import { Arrow, ArrowType } from "./arrow.component"
import { Play } from "./play.component"
import { Pause } from "./pause.component"
import { AudioPlayerEQ } from "./audio-player-eq.component"
import { useAudioHook } from "./audio-player.hook"
import {
  AudioPlayerContainer,
  AudioPlayerButtons,
  AudioPlayerButton,
  TimeLineContainer,
  AudioTimer,
  SongTitle,
} from "./audio-player.styled"

export interface TrackProps {
  url: string
  title: string
}

export interface AudioPlayerProps {
  tracks: TrackProps[]
}

export const AudioPlayer: AppFunctionComponent<AudioPlayerProps> = ({
  tracks,
}) => {
  const {
    playing,
    play,
    pause,
    next,
    prev,
    displayNextPrev,
    currentTrack,
    audioRef,
    duration,
    playTime,
  } = useAudioHook(tracks)

  return (
    <>
      {currentTrack.title && <SongTitle>{currentTrack.title}</SongTitle>}
      <AudioPlayerContainer>
        <audio
          data-testid="audio"
          ref={audioRef}
          onEnded={playing ? pause : play}
        >
          <source
            data-testid="audio-source"
            src={currentTrack.url}
            type="audio/mpeg"
          />
          Your browser does not support the audio element.
        </audio>
        <AudioPlayerButtons withNextPrev={displayNextPrev}>
          {displayNextPrev && (
            <AudioPlayerButton data-testid="audio-prev" onClick={prev}>
              <Arrow
                arrowType={ArrowType.Prev}
                title={"Play previous ringtone"}
              />
            </AudioPlayerButton>
          )}
          <AudioPlayerButton
            data-testid="audio-play-pause"
            onClick={playing ? pause : play}
          >
            {playing ? <Pause /> : <Play />}
          </AudioPlayerButton>
          {displayNextPrev && (
            <AudioPlayerButton data-testid="audio-next" onClick={next}>
              <Arrow arrowType={ArrowType.Next} title={"Play next ringtone"} />
            </AudioPlayerButton>
          )}
        </AudioPlayerButtons>
        <TimeLineContainer>
          <AudioTimer data-testid="audio-play-time">{playTime}</AudioTimer>
          <AudioPlayerEQ
            bar={50}
            playing={playing}
            currentTrack={currentTrack.url}
          />
          <AudioTimer data-testid="audio-duration">{duration}</AudioTimer>
        </TimeLineContainer>
      </AudioPlayerContainer>
    </>
  )
}
